import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(() => ({
	wrapper: {
		border: "1px dashed #d1d5db",
		borderRadius: "4px",
		padding: "24px",
		textAlign: "center",
		backgroundColor: "#fafafa",
	},
	heading: {
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: "15px",
		marginBottom: "8px",
	},
	body: {
		fontFamily: "Roboto",
		fontSize: "13px",
		color: "#6b7280",
	},
}));

const ReportSubscriptionsEmptyState = () => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div className={classes.wrapper}>
			<Typography className={classes.heading}>
				{t("message.noReportSubscriptionsYet")}
			</Typography>
			<Typography className={classes.body}>
				{t("message.reportSubscriptionsEmptyBody")}
			</Typography>
		</div>
	);
};

export default ReportSubscriptionsEmptyState;
